import React, { useState, useEffect } from 'react';
import './index.css';
import Popup from '../Popup/Popup';

const MiniAppForm = ({ onSubmit }) => {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        developer_name: '',
        developer_contact: '',
        category: '', // Will hold category ID
        miniapp_link: '',
        icon: null,
        screenshots: [],
    });

    const [categories, setCategories] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const apiUrl = process.env.REACT_APP_API_URL
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await fetch(`${apiUrl}apps/categories/`); 
                const data = await response.json();
                setCategories(data);
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };

        fetchCategories();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        if (type === 'file') {
            if (name === 'screenshots') {
                setFormData({
                    ...formData,
                    screenshots: files,
                });
            } else {
                setFormData({
                    ...formData,
                    [name]: files[0],
                });
            }
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = new FormData();
        for (const key in formData) {
            if (key === 'screenshots') {
                for (let i = 0; i < formData.screenshots.length; i++) {
                    data.append('screenshots', formData.screenshots[i]);
                }
            } else {
                data.append(key, formData[key]);
            }
        }

        if (onSubmit) {
            onSubmit(data).then(() => {
                setShowPopup(true);
                setFormData({
                    name: '',
                    description: '',
                    developer_name: '',
                    developer_contact: '',
                    category: '',
                    miniapp_link: '',
                    icon: null,
                    screenshots: [],
                });
            });
        }
    };

    const closePopup = () => {
        setShowPopup(false);
    };

    return (
        <div>
            <form onSubmit={handleSubmit} className="mini-app-form">
                <div className="form-group">
                    <label htmlFor="name">App Name:</label>
                    <input 
                        type="text" 
                        id="name" 
                        name="name" 
                        value={formData.name} 
                        onChange={handleChange} 
                        placeholder="Enter app name"
                        required 
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="description">Description:</label>
                    <textarea 
                        id="description" 
                        name="description" 
                        value={formData.description} 
                        onChange={handleChange} 
                        placeholder="Enter app description"
                        required 
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="developer_name">Developer Name:</label>
                    <input 
                        type="text" 
                        id="developer_name" 
                        name="developer_name" 
                        value={formData.developer_name} 
                        onChange={handleChange} 
                        placeholder="Enter developer name"
                        required 
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="developer_contact">Developer Contact:</label>
                    <input 
                        type="email" 
                        id="developer_contact" 
                        name="developer_contact" 
                        value={formData.developer_contact} 
                        onChange={handleChange} 
                        placeholder="Enter developer contact email"
                        required 
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="category">Category:</label>
                    <select 
                        id="category" 
                        name="category" 
                        value={formData.category} 
                        onChange={handleChange} 
                        required 
                    >
                        <option value="">Select a category</option>
                        {categories.map(category => (
                            <option key={category.id} value={category.id}>
                                {category.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="miniapp_link">Mini App Link:</label>
                    <input 
                        type="url" 
                        id="miniapp_link" 
                        name="miniapp_link" 
                        value={formData.miniapp_link} 
                        onChange={handleChange} 
                        placeholder="Enter mini app link"
                        required 
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="icon">App Icon:</label>
                    <input 
                        type="file" 
                        id="icon" 
                        name="icon" 
                        accept="image/*" 
                        onChange={handleChange} 
                        placeholder="Upload app icon"
                        required 
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="screenshots">Screenshots:</label>
                    <input 
                        type="file" 
                        id="screenshots" 
                        name="screenshots" 
                        accept="image/*" 
                        onChange={handleChange} 
                        placeholder="Upload app screenshots"
                        multiple 
                    />
                </div>
                <button type="submit" className="submit-button">Submit for Moderation</button>
            </form>

            {showPopup && <Popup onClose={closePopup} />}
        </div>
    );
};

export default MiniAppForm;
